var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTruckIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    className: "Locker",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 11H14V7H17C17.552 7 18 7.448 18 8V11ZM18 15H17.221C16.672 14.39 15.885 14 15 14C14.647 14 14.314 14.072 14 14.184V13H18V15ZM15 18C14.449 18 14 17.551 14 17C14 16.449 14.449 16 15 16C15.551 16 16 16.449 16 17C16 17.551 15.551 18 15 18ZM12 5V15H9.484C9.038 13.278 7.487 12 5.625 12C4.538 12 3.556 12.436 2.838 13.142C2.526 13.448 2 13.216 2 12.779V3C2 2.448 2.448 2 3 2H11C11.552 2 12 2.448 12 3V5ZM7.347 17C7 17.595 6.362 18 5.625 18C4.888 18 4.25 17.595 3.903 17C3.731 16.705 3.625 16.366 3.625 16C3.625 15.634 3.731 15.295 3.903 15C4.25 14.405 4.888 14 5.625 14C6.362 14 7 14.405 7.347 15C7.519 15.295 7.625 15.634 7.625 16C7.625 16.366 7.519 16.705 7.347 17ZM18 5H14V2C14 0.895 13.105 0 12 0H2C0.895 0 0 0.895 0 2V15.234C0 16.209 0.791001 17 1.766 17C2.213 18.722 3.763 20 5.625 20C7.487 20 9.037 18.722 9.484 17H12C12 18.657 13.343 20 15 20C16.657 20 18 18.657 18 17C19.105 17 20 16.105 20 15V7C20 5.895 19.105 5 18 5Z",
    fill: "#F68424"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckIcon);
export default __webpack_public_path__ + "static/media/truckIcon.ae77aa2331bcf50e4ca47d13bb84c0d7.svg";
export { ForwardRef as ReactComponent };